import { Alert, Box, Snackbar } from "@mui/material"
import { useState, useEffect, useCallback } from "react";
import { useAtom } from "jotai";
import punchListAtom, { fetchpunchlistAtom } from "../../../atoms/quality/QualityAtoms";
import TableComponent from "./TableComponent";
import { punlistcolumns } from "../../../shared/constent/constent";
import PunchlistHeader from "./header";
import { useNavigate } from "react-router-dom";
import { DownloadExcelFile } from "../../../shared/Helper";
import settingsAtom from "../../../atoms/settings/SettingsAtom";
import DeleteQcPunchlistItemModal from "./DeleteDialogComponent";
import axiosInstance from "../../../utils/axios";

const Punchlist = () => {
    const navigate = useNavigate()
    const [view, setView] = useState("list view")
    const [active, setActive] = useState("external");
    const [loader, setLoader] = useState(false);
    const [, setPunchlist] = useAtom(fetchpunchlistAtom);
    const [list] = useAtom(punchListAtom);
    const { data = {} } = list;
    const [initialFilter, setInitialFilter] = useState({})
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
      });
    const [filters, setFilters] = useState([]);
    const getResult = (data) => {
        return data?.reduce((acc, item) => ({ ...acc, ...item }), {});
    };
    const [lists, setList] = useState({
        block: [],
        section: [],
        row: [],
        checkpoint_names: [],
        statuses: [],
        scope: [],
        times: []
      });
    const [currentFilter, setCurrentFilter] = useState({
        block: [],
        section: [],
        row: [],
        checkpoint_names: [],
        statuses: [],
        scope: [],
        times: []
    });
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, severity: 'success', message: '' });
    const [colValue, setColValue] = useState([]);
    const [settingsData] = useAtom(settingsAtom)
    const { projectList } = settingsData;
    const currentProject = projectList.find(o => o.id === parseInt(localStorage.getItem("project_id")));
    const [selectedRows, setSelectedRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);

    const filterableColumns = [ "block", "row", "section", "status", "scope", "checkpoint","time_stamp"];

    useEffect(() => {
        if (view === "map view") {
            navigate("mapview")
        }
        // eslint-disable-next-line
    }, [view])
    
    const init = useCallback(async () => {
        setLoader(true)

        const currentValues = getResult(filters);
        try {
            if(filters?.length) {
                await setPunchlist({
                    ...currentValues,
                    "page": paginationModel?.page + 1,
                    "page_size": paginationModel?.pageSize,

                })
            } else {
                await setPunchlist({
                    "page": paginationModel?.page + 1,
                    "page_size": paginationModel?.pageSize,
                })
            }
        } catch (err) {
            console.error(err)
        } finally {
            setLoader(false)
        }
    }, [setPunchlist, paginationModel, filters]);

    useEffect(() => {
        init()
    }, [init]);

    useEffect(() => {
        if (data?.filter_values && filters?.length === 0) {
          setInitialFilter(data.filter_values);
          setList(data.filter_values);
          setCurrentFilter(
            {
                block: [],
                section: [],
                row: [],
                checkpoint_name: [],
                status: [],
                scope: [], 
                times: []
            }
        )
        } else if (filters?.length) {
          const filterKeys = filters
                            .map(f => Object.keys(f)[0])
                            .filter((_, index) => index === 0)
      
          const resetFilterValues = filterKeys.reduce((acc, key) => {
            acc[key] = initialFilter[key];
            return acc;
          }, {});

          setList({
            ...data.filter_values,
            ...resetFilterValues,
          });

          setCurrentFilter(data.filter_values)

        }
      }, [data, filters, initialFilter]);
      

    const externalData = (data?.data?.qcpunchlist_external && Object.values(data?.data?.qcpunchlist_external)) || [];
    const internalData = (data?.data?.qcpunchlist_internal && Object.values(data?.data?.qcpunchlist_internal)) || [];

    const handleClearFilter = () => {
        setCurrentFilter(
            {
                block: [],
                section: [],
                row: [],
                checkpoint_name: [],
                status: [],
                scope: [], 
                times: []
            }
        )
        setFilters([])
        setList(
            {
                block: [],
                section: [],
                row: [],
                checkpoint_name: [],
                status: [],
                scope: [], 
                times: []
            }
        )
        setSelectedRows([])
        setRowSelectionModel([])
    }

    const handleDownload = async () => {
        const data = active === "external" ? externalData : internalData;
        setLoading(true);
        try {
          DownloadExcelFile(colValue, data, currentProject, setSnackbar, "QC Punchlist")
          setSnackbar({ open: true, message: 'Downloaded Punchlist Data', severity: 'success' });
        } catch (err) {
          setSnackbar({ open: true, severity: 'error', message: 'Error downloading Excel.' });
          console.error(err);
        } finally {
          setLoading(false);
        }
    }

    const handleDelete = async (value) => {
        setLoading(true)
        try {
            const result = selectedRows.map((item) => {
                if(!item?.pier_id && !item?.tt_id) {
                    return  {
                        id: item?.id,
                        type: "tracker_row",
                        status: value,
                        block_id: item?.block_id
                    }
                } else if(item?.pier_id) {
                    return  {
                        id: item?.id,
                        type: "piers",
                        status: value,
                        block_id: item?.block_id
                    }
                } else {
                    return  {
                        id: item?.id,
                        type: "tt",
                        status: value,
                        block_id: item?.block_id
                    }
                }
               
            })

            const res = await axiosInstance.post(`/projects/update_punchlist_status`, result)

            if(res?.data) {
                await setPunchlist({
                    "page": paginationModel?.page + 1,
                    "per_page": paginationModel?.pageSize,
                })
                setSelectedRows([])
            }

        } catch(error) {
            console.error(error)
        } finally {
            setLoading(false)
            setOpen(false)
        }
    }

    return (
        <Box px={4} py={2} mt={1.5}>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
            </Snackbar>

            <PunchlistHeader
                active={active}
                setActive={setActive}
                handleClearFilter={handleClearFilter}
                view={view}
                setView={setView}
                loading={loading}
                handleDownload={handleDownload}
                selectedRows={selectedRows}
                handleDelete={setOpen}
                open={open}
            />

            <TableComponent
                data={active === "external" ? externalData : internalData} 
                initialColumns={punlistcolumns}
                count={active === "external" ? data?.data?.pagination?.total_count : data?.data?.pagination?.total_count}
                loader={loader}
                setLoader={setLoader}
                paginationModel={paginationModel} 
                setPaginationModel={setPaginationModel}
                filters={filters}
                setFilters={setFilters}
                initialFilter={initialFilter}
                setPunchlist={setPunchlist}
                list={lists} 
                setList={setList}
                currentFilterValue={currentFilter} 
                setCurrentFilterValue={setCurrentFilter}
                colValue={colValue} 
                setColValue={setColValue}
                active={active}
                selectedRows={selectedRows} 
                setSelectedRows = {setSelectedRows}
                rowSelectionModel={rowSelectionModel} 
                setRowSelectionModel={setRowSelectionModel}
                filterableColumns={filterableColumns}
            />

            <DeleteQcPunchlistItemModal 
                open={open} 
                onClose={() => setOpen(false)} 
                onDelete={handleDelete} 
            />
        </Box>
      
    )
}

export default Punchlist;